// extracted by mini-css-extract-plugin
export default {"remove":"removableTag_remove__s1bl0O5Z","removeIcon":"removableTag_removeIcon__AzTrpH22"};